export default function DownloadCta() {
  return (
    <section id="download" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-site mx-auto px-4 md:px-6">
        <div className="relative rounded-lg overflow-hidden bg-primary-600">
          <div className="grid grid-cols-1 lg:grid-cols-2 items-center">
            <div className="p-6 md:p-10 lg:p-12">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/15 text-background-50/90 text-xs font-medium">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-smartphone-line"></i>
                </span>
                客户端下载
              </span>
              <h2 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-background-50 leading-snug">
                下载客户端，关注与私信别错过
              </h2>
              <p className="mt-3 text-sm md:text-base text-background-50/85 leading-relaxed max-w-md">
                移动端接收关注动态和私信实时提醒，评论区打字、追评、@ 用户都与网页端保持同步。同一个账号，登录哪一端都能接着聊。
              </p>

              <div className="mt-7 flex flex-col sm:flex-row gap-3">
                <a
                  href="#top"
                  className="h-11 px-5 rounded-md bg-background-50 text-primary-700 text-sm font-medium inline-flex items-center justify-center gap-2 hover:bg-background-100 transition-colors whitespace-nowrap"
                >
                  <i className="ri-apple-fill text-base"></i>
                  iOS 下载
                </a>
                <a
                  href="#top"
                  className="h-11 px-5 rounded-md bg-background-50 text-primary-700 text-sm font-medium inline-flex items-center justify-center gap-2 hover:bg-background-100 transition-colors whitespace-nowrap"
                >
                  <i className="ri-android-fill text-base"></i>
                  Android 下载
                </a>
                <a
                  href="#top"
                  className="h-11 px-5 rounded-md border border-background-50/40 text-background-50 text-sm font-medium inline-flex items-center justify-center gap-2 hover:bg-background-50/10 transition-colors whitespace-nowrap"
                >
                  <i className="ri-computer-line text-base"></i>
                  网页版直接进
                </a>
              </div>

              <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-background-50/75">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-check-line"></i>
                  安装包约 42 MB
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-check-line"></i>
                  支持消息免打扰
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-check-line"></i>
                  账号登录进度同步
                </span>
              </div>
            </div>

            <div className="w-full h-[240px] md:h-[380px] lg:h-[440px] bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Minimal%20flat%20lay%20mockup%20of%20a%20smartphone%20displaying%20a%20clean%20community%20feed%20interface%20in%20warm%20orange%20and%20cream%20tones%2C%20notebook%20and%20coffee%20cup%20beside%20it%2C%20soft%20natural%20light%2C%20editorial%20product%20photography%2C%20neutral%20beige%20background%2C%20high%20detail&width=1200&height=800&seq=hlzt-app-02&orientation=landscape"
                alt="黑料社区客户端界面示意，评论与私信在移动端同步"
                title="黑料社区客户端 - 关注粉丝私信交流"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}